export default __webpack_public_path__ + "static/media/4.180e2ef7.png";